import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	importedUser: {
		id: 'project-create-importer-upload-flow.csv-user-mapping-screen.user-mapping-table.imported-user',
		defaultMessage: 'Users moving to Jira ({numberOfUsers})',
		description: 'Table header for imported users',
	},
	textFieldPlaceholder: {
		id: 'project-create-importer-upload-flow.csv-user-mapping-screen.user-mapping-table.text-field-placeholder',
		defaultMessage: 'Enter email',
		description: 'Placeholder text for email text field',
	},
	textFieldLabel: {
		id: 'project-create-importer-upload-flow.csv-user-mapping-screen.user-mapping-table.text-field-label',
		defaultMessage: 'Enter email for {name}',
		description: 'Message shown when there are no users to map',
	},
	noUsers: {
		id: 'project-create-importer-upload-flow.csv-user-mapping-screen.user-mapping-table.no-users',
		defaultMessage: 'There are no users in your CSV',
		description: 'Message shown when there are no users to map',
	},
});
